import { Button, Col, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import Select from "src/components/Select/Select";
import useForm, { ICallbackSubmit } from "src/hooks/useForm";
import useLazyFetch from "src/hooks/useLazyFetch";
import * as yup from "yup";

interface IProps {
  initialValues: {
    id: number | string;
    name: string;
    device_id: string;
  };
  onClose: () => void;
}

const PinDevice = ({ initialValues, onClose }: IProps) => {
    const [onSetPin,] = useLazyFetch({
        url: "https://api.automa.id/api/iot/lock/bridges/devices/setpin/"+initialValues.id,
        method: "POST"
    })
  const validation = () => {
    const selectYup = yup.object().shape({
      label: yup.string().nullable().required("Required"),
      value: yup.string().nullable().required("Required"),
    });
    return yup.object().shape({
      pin: yup.string().required("Pin is required"),
      pinType: selectYup,
      startDate: yup.string().required("Start Date is required"),
    });
  };
  const {
    handleSubmit,
    errors,
    values,
    handleChange,
    isSubmitting,
    isValid,
    handleReset,
    setFieldValue,
  } = useForm({
    initialValues: {
      pin: "",
      pinType: null,
      startDate: "",
      endDate: "",
    },
    validation: validation(),
  });

  const onSubmit:ICallbackSubmit = (values, {setSubmitting}) => {
    setSubmitting(true)
    onSetPin({
        body: {
            pin: values.pin,
            pinType: values.pinType.value,
            startDate: `${values.startDate}`.replace("T", " "),
            endDate: `${values.endDate}`.replace("T", " "),
        }
    },()=>{
        setSubmitting(false);
        handleReset();
    })
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup row>
          <Col md="3">
            <Label htmlFor="pin">Pin</Label>
          </Col>
          <Col xs="12" md="9">
            <Input
              type="text"
              name="pin"
              id="pin"
              placeholder="Pin"
              autoComplete="off"
              valid={!errors.pin}
              invalid={!!errors.pin}
              onChange={handleChange}
              value={values.pin}
              disabled={isSubmitting}
            />
            <FormFeedback>{errors.pin}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <Label htmlFor="pinType">Pin Type</Label>
          </Col>
          <Col xs="12" md="9">
            <Select
              name={"Option"}
              onChange={(value) => {
                setFieldValue("pinType", value);
              }}
              option={[
                { label: "One Time", value: "1" },
                { label: "Duration", value: "4" },
              ]}
              value={values.pinType}
              page={{ of: 1 }}
              totalPage={1}
              onPage={() => null}
              onKeypress={() => null}
              loading={false}
            />
            <FormFeedback>{errors.pinType}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col md="3">
            <Label htmlFor="startDate">Start Date</Label>
          </Col>
          <Col xs="12" md="6">
            <Input
              type="datetime-local"
              name="startDate"
              id="startDate"
              placeholder="Start Date"
              autoComplete="off"
              valid={!errors.startDate}
              invalid={!!errors.startDate}
              onChange={handleChange}
              value={values.startDate}
              disabled={isSubmitting}
            />
            <FormFeedback>{errors.startDate}</FormFeedback>
          </Col>
          <Col xs="12" md="3">
            <Button
              type="button"
              onClick={() =>
                setFieldValue(
                  "startDate",
                  new Date(new Date().getTime() + ((new Date().getTimezoneOffset()/-60) * 60 * 60 * 1000)).toISOString().slice(0, -8)
                )
              }
            >
              Today
            </Button>
          </Col>
        </FormGroup>
        {values.pinType?.value === "4" ? (
          <FormGroup row>
            <Col md="3">
              <Label htmlFor="endDate">End Date</Label>
            </Col>
            <Col xs="12" md="6">
              <Input
                type="datetime-local"
                name="endDate"
                id="endDate"
                placeholder="End Date"
                autoComplete="off"
                valid={!errors.endDate}
                invalid={!!errors.endDate}
                onChange={handleChange}
                value={values.endDate}
                disabled={isSubmitting}
              />
              <FormFeedback>{errors.endDate}</FormFeedback>
            </Col>
            <Col xs="12" md="3">
              <Button
                type="button"
                onClick={() =>
                  setFieldValue(
                    "endDate",
                    new Date(new Date().getTime() + ((new Date().getTimezoneOffset()/-60) * 60 * 60 * 1000)).toISOString().slice(0, -8)
                  )
                }
              >
                Today
              </Button>
            </Col>
          </FormGroup>
        ) : null}
        <FormGroup>
          <div className="d-flex justify-content-end w-100">
            <Button
              type="reset"
              color="danger"
              className="mr-1 w-25"
              disabled={isSubmitting}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              type="button"
              color="warning"
              className="mr-1 w-25"
              disabled={isSubmitting}
              onClick={() => onClose()}
            >
              Close
            </Button>

            <Button
              type="submit"
              color="primary"
              className="mr-1 w-50"
              disabled={isSubmitting || !isValid}
            >
              {isSubmitting ? "Wait..." : "Send"}
            </Button>
          </div>
        </FormGroup>
      </form>
    </>
  );
};

export default PinDevice;
